/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/sub_growth.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { PaymentMethod } from "./common_enums";
import { BillingPlatform } from "./common_enums";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.SubGrowth
 */
export interface SubGrowth {
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp activated_at = 1;
     */
    activated_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp add_ons_trial_ends_at = 2;
     */
    add_ons_trial_ends_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp add_ons_trial_started_at = 3;
     */
    add_ons_trial_started_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp base_trial_ends_at = 4;
     */
    base_trial_ends_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp base_trial_started_at = 5;
     */
    base_trial_started_at?: Timestamp;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.BillingPlatform billing_platform = 6;
     */
    billing_platform?: BillingPlatform;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp canceled_at = 7;
     */
    canceled_at?: Timestamp;
    /**
     * @generated from protobuf field: optional string collection_method = 8;
     */
    collection_method?: string;
    /**
     * @generated from protobuf field: optional string coupon = 9;
     */
    coupon?: string;
    /**
     * @generated from protobuf field: optional string currency = 10;
     */
    currency?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp current_period_ends_at = 11;
     */
    current_period_ends_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp current_period_started_at = 12;
     */
    current_period_started_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp expires_at = 13;
     */
    expires_at?: Timestamp;
    /**
     * @generated from protobuf field: optional string generated_offer_code = 14;
     */
    generated_offer_code?: string;
    /**
     * @generated from protobuf field: optional int32 interval_len = 15;
     */
    interval_len?: number;
    /**
     * @generated from protobuf field: optional int32 interval_unit = 16;
     */
    interval_unit?: number;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp paused_at = 17;
     */
    paused_at?: Timestamp;
    /**
     * @generated from protobuf field: repeated string previous_product_add_ons = 18;
     */
    previous_product_add_ons: string[];
    /**
     * @generated from protobuf field: repeated string previous_product_base = 19;
     */
    previous_product_base: string[];
    /**
     * @generated from protobuf field: optional int32 previous_amount_in_cents = 20;
     */
    previous_amount_in_cents?: number;
    /**
     * @generated from protobuf field: repeated string product_add_ons = 21;
     */
    product_add_ons: string[];
    /**
     * Use product message?
     *
     * @generated from protobuf field: repeated string product_base = 22;
     */
    product_base: string[];
    /**
     * @generated from protobuf field: optional string rate_plan_code = 23;
     */
    rate_plan_code?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp resume_at = 24;
     */
    resume_at?: Timestamp;
    /**
     * @generated from protobuf field: optional string state = 25;
     */
    state?: string;
    /**
     * @generated from protobuf field: optional int32 amount_in_cents = 26;
     */
    amount_in_cents?: number;
    /**
     * @generated from protobuf field: optional int32 total_pause_cycles = 27;
     */
    total_pause_cycles?: number;
    /**
     * @generated from protobuf field: repeated string updated_product_add_ons = 28;
     */
    updated_product_add_ons: string[];
    /**
     * @generated from protobuf field: repeated string updated_product_base = 29;
     */
    updated_product_base: string[];
    /**
     * @generated from protobuf field: optional int32 updated_amount_in_cents = 30;
     */
    updated_amount_in_cents?: number;
    /**
     * @generated from protobuf field: optional string uuid = 31;
     */
    uuid?: string;
    /**
     * @generated from protobuf field: optional string discount = 32;
     */
    discount?: string;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.PaymentMethod payment_method = 33;
     */
    payment_method?: PaymentMethod;
}
// @generated message type with reflection information, may provide speed optimized methods
class SubGrowth$Type extends MessageType<SubGrowth> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.SubGrowth", [
            { no: 1, name: "activated_at", kind: "message", localName: "activated_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of activating account in RFC 3339 format." } },
            { no: 2, name: "add_ons_trial_ends_at", kind: "message", localName: "add_ons_trial_ends_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Right now add_ons trial is same as base trial." } },
            { no: 3, name: "add_ons_trial_started_at", kind: "message", localName: "add_ons_trial_started_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Right now add_ons trial is same as base trial." } },
            { no: 4, name: "base_trial_ends_at", kind: "message", localName: "base_trial_ends_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of base trial ends in RFC 3339 format." } },
            { no: 5, name: "base_trial_started_at", kind: "message", localName: "base_trial_started_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of base trial starts in RFC 3339 format." } },
            { no: 6, name: "billing_platform", kind: "enum", localName: "billing_platform", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.BillingPlatform", BillingPlatform], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "apple", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Payment platform used to subscribe." } },
            { no: 7, name: "canceled_at", kind: "message", localName: "canceled_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of canceling in RFC 3339 format." } },
            { no: 8, name: "collection_method", kind: "scalar", localName: "collection_method", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "automatic", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "payment collection method." } },
            { no: 9, name: "coupon", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 10, name: "currency", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "US", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Currency type: US, Euro, etc." } },
            { no: 11, name: "current_period_ends_at", kind: "message", localName: "current_period_ends_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "End time of the subscription in RFC 3339 format." } },
            { no: 12, name: "current_period_started_at", kind: "message", localName: "current_period_started_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Start time of the subscription in RFC 3339 format." } },
            { no: 13, name: "expires_at", kind: "message", localName: "expires_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 14, name: "generated_offer_code", kind: "scalar", localName: "generated_offer_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 15, name: "interval_len", kind: "scalar", localName: "interval_len", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 16, name: "interval_unit", kind: "scalar", localName: "interval_unit", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 17, name: "paused_at", kind: "message", localName: "paused_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Pause subscription time of the account in RFC 3339 format." } },
            { no: 18, name: "previous_product_add_ons", kind: "scalar", localName: "previous_product_add_ons", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Existing addons that the user upgraded from." } },
            { no: 19, name: "previous_product_base", kind: "scalar", localName: "previous_product_base", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Existing base that the user upgraded from." } },
            { no: 20, name: "previous_amount_in_cents", kind: "scalar", localName: "previous_amount_in_cents", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Existing total cost for the subscription that the user upgraded from." } },
            { no: 21, name: "product_add_ons", kind: "scalar", localName: "product_add_ons", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "New addons that the user upgraded to." } },
            { no: 22, name: "product_base", kind: "scalar", localName: "product_base", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "New base that the user upgraded to." } },
            { no: 23, name: "rate_plan_code", kind: "scalar", localName: "rate_plan_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 24, name: "resume_at", kind: "message", localName: "resume_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Resume subscription time of the account in RFC 3339 format." } },
            { no: 25, name: "state", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 26, name: "amount_in_cents", kind: "scalar", localName: "amount_in_cents", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "New total cost for the subscription that the user upgraded to." } },
            { no: 27, name: "total_pause_cycles", kind: "scalar", localName: "total_pause_cycles", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 28, name: "updated_product_add_ons", kind: "scalar", localName: "updated_product_add_ons", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 29, name: "updated_product_base", kind: "scalar", localName: "updated_product_base", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 30, name: "updated_amount_in_cents", kind: "scalar", localName: "updated_amount_in_cents", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 31, name: "uuid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 32, name: "discount", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 33, name: "payment_method", kind: "enum", localName: "payment_method", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.PaymentMethod", PaymentMethod], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "cash_app", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Payment method used to subscribe." } }
        ]);
    }
    create(value?: PartialMessage<SubGrowth>): SubGrowth {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.previous_product_add_ons = [];
        message.previous_product_base = [];
        message.product_add_ons = [];
        message.product_base = [];
        message.updated_product_add_ons = [];
        message.updated_product_base = [];
        if (value !== undefined)
            reflectionMergePartial<SubGrowth>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubGrowth): SubGrowth {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional google.protobuf.Timestamp activated_at */ 1:
                    message.activated_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.activated_at);
                    break;
                case /* optional google.protobuf.Timestamp add_ons_trial_ends_at */ 2:
                    message.add_ons_trial_ends_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.add_ons_trial_ends_at);
                    break;
                case /* optional google.protobuf.Timestamp add_ons_trial_started_at */ 3:
                    message.add_ons_trial_started_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.add_ons_trial_started_at);
                    break;
                case /* optional google.protobuf.Timestamp base_trial_ends_at */ 4:
                    message.base_trial_ends_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.base_trial_ends_at);
                    break;
                case /* optional google.protobuf.Timestamp base_trial_started_at */ 5:
                    message.base_trial_started_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.base_trial_started_at);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.BillingPlatform billing_platform */ 6:
                    message.billing_platform = reader.int32();
                    break;
                case /* optional google.protobuf.Timestamp canceled_at */ 7:
                    message.canceled_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.canceled_at);
                    break;
                case /* optional string collection_method */ 8:
                    message.collection_method = reader.string();
                    break;
                case /* optional string coupon */ 9:
                    message.coupon = reader.string();
                    break;
                case /* optional string currency */ 10:
                    message.currency = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp current_period_ends_at */ 11:
                    message.current_period_ends_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.current_period_ends_at);
                    break;
                case /* optional google.protobuf.Timestamp current_period_started_at */ 12:
                    message.current_period_started_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.current_period_started_at);
                    break;
                case /* optional google.protobuf.Timestamp expires_at */ 13:
                    message.expires_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expires_at);
                    break;
                case /* optional string generated_offer_code */ 14:
                    message.generated_offer_code = reader.string();
                    break;
                case /* optional int32 interval_len */ 15:
                    message.interval_len = reader.int32();
                    break;
                case /* optional int32 interval_unit */ 16:
                    message.interval_unit = reader.int32();
                    break;
                case /* optional google.protobuf.Timestamp paused_at */ 17:
                    message.paused_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.paused_at);
                    break;
                case /* repeated string previous_product_add_ons */ 18:
                    message.previous_product_add_ons.push(reader.string());
                    break;
                case /* repeated string previous_product_base */ 19:
                    message.previous_product_base.push(reader.string());
                    break;
                case /* optional int32 previous_amount_in_cents */ 20:
                    message.previous_amount_in_cents = reader.int32();
                    break;
                case /* repeated string product_add_ons */ 21:
                    message.product_add_ons.push(reader.string());
                    break;
                case /* repeated string product_base */ 22:
                    message.product_base.push(reader.string());
                    break;
                case /* optional string rate_plan_code */ 23:
                    message.rate_plan_code = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp resume_at */ 24:
                    message.resume_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.resume_at);
                    break;
                case /* optional string state */ 25:
                    message.state = reader.string();
                    break;
                case /* optional int32 amount_in_cents */ 26:
                    message.amount_in_cents = reader.int32();
                    break;
                case /* optional int32 total_pause_cycles */ 27:
                    message.total_pause_cycles = reader.int32();
                    break;
                case /* repeated string updated_product_add_ons */ 28:
                    message.updated_product_add_ons.push(reader.string());
                    break;
                case /* repeated string updated_product_base */ 29:
                    message.updated_product_base.push(reader.string());
                    break;
                case /* optional int32 updated_amount_in_cents */ 30:
                    message.updated_amount_in_cents = reader.int32();
                    break;
                case /* optional string uuid */ 31:
                    message.uuid = reader.string();
                    break;
                case /* optional string discount */ 32:
                    message.discount = reader.string();
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.PaymentMethod payment_method */ 33:
                    message.payment_method = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubGrowth, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional google.protobuf.Timestamp activated_at = 1; */
        if (message.activated_at)
            Timestamp.internalBinaryWrite(message.activated_at, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp add_ons_trial_ends_at = 2; */
        if (message.add_ons_trial_ends_at)
            Timestamp.internalBinaryWrite(message.add_ons_trial_ends_at, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp add_ons_trial_started_at = 3; */
        if (message.add_ons_trial_started_at)
            Timestamp.internalBinaryWrite(message.add_ons_trial_started_at, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp base_trial_ends_at = 4; */
        if (message.base_trial_ends_at)
            Timestamp.internalBinaryWrite(message.base_trial_ends_at, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp base_trial_started_at = 5; */
        if (message.base_trial_started_at)
            Timestamp.internalBinaryWrite(message.base_trial_started_at, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.BillingPlatform billing_platform = 6; */
        if (message.billing_platform !== undefined)
            writer.tag(6, WireType.Varint).int32(message.billing_platform);
        /* optional google.protobuf.Timestamp canceled_at = 7; */
        if (message.canceled_at)
            Timestamp.internalBinaryWrite(message.canceled_at, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional string collection_method = 8; */
        if (message.collection_method !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.collection_method);
        /* optional string coupon = 9; */
        if (message.coupon !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.coupon);
        /* optional string currency = 10; */
        if (message.currency !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.currency);
        /* optional google.protobuf.Timestamp current_period_ends_at = 11; */
        if (message.current_period_ends_at)
            Timestamp.internalBinaryWrite(message.current_period_ends_at, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp current_period_started_at = 12; */
        if (message.current_period_started_at)
            Timestamp.internalBinaryWrite(message.current_period_started_at, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp expires_at = 13; */
        if (message.expires_at)
            Timestamp.internalBinaryWrite(message.expires_at, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional string generated_offer_code = 14; */
        if (message.generated_offer_code !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.generated_offer_code);
        /* optional int32 interval_len = 15; */
        if (message.interval_len !== undefined)
            writer.tag(15, WireType.Varint).int32(message.interval_len);
        /* optional int32 interval_unit = 16; */
        if (message.interval_unit !== undefined)
            writer.tag(16, WireType.Varint).int32(message.interval_unit);
        /* optional google.protobuf.Timestamp paused_at = 17; */
        if (message.paused_at)
            Timestamp.internalBinaryWrite(message.paused_at, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated string previous_product_add_ons = 18; */
        for (let i = 0; i < message.previous_product_add_ons.length; i++)
            writer.tag(18, WireType.LengthDelimited).string(message.previous_product_add_ons[i]);
        /* repeated string previous_product_base = 19; */
        for (let i = 0; i < message.previous_product_base.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.previous_product_base[i]);
        /* optional int32 previous_amount_in_cents = 20; */
        if (message.previous_amount_in_cents !== undefined)
            writer.tag(20, WireType.Varint).int32(message.previous_amount_in_cents);
        /* repeated string product_add_ons = 21; */
        for (let i = 0; i < message.product_add_ons.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.product_add_ons[i]);
        /* repeated string product_base = 22; */
        for (let i = 0; i < message.product_base.length; i++)
            writer.tag(22, WireType.LengthDelimited).string(message.product_base[i]);
        /* optional string rate_plan_code = 23; */
        if (message.rate_plan_code !== undefined)
            writer.tag(23, WireType.LengthDelimited).string(message.rate_plan_code);
        /* optional google.protobuf.Timestamp resume_at = 24; */
        if (message.resume_at)
            Timestamp.internalBinaryWrite(message.resume_at, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* optional string state = 25; */
        if (message.state !== undefined)
            writer.tag(25, WireType.LengthDelimited).string(message.state);
        /* optional int32 amount_in_cents = 26; */
        if (message.amount_in_cents !== undefined)
            writer.tag(26, WireType.Varint).int32(message.amount_in_cents);
        /* optional int32 total_pause_cycles = 27; */
        if (message.total_pause_cycles !== undefined)
            writer.tag(27, WireType.Varint).int32(message.total_pause_cycles);
        /* repeated string updated_product_add_ons = 28; */
        for (let i = 0; i < message.updated_product_add_ons.length; i++)
            writer.tag(28, WireType.LengthDelimited).string(message.updated_product_add_ons[i]);
        /* repeated string updated_product_base = 29; */
        for (let i = 0; i < message.updated_product_base.length; i++)
            writer.tag(29, WireType.LengthDelimited).string(message.updated_product_base[i]);
        /* optional int32 updated_amount_in_cents = 30; */
        if (message.updated_amount_in_cents !== undefined)
            writer.tag(30, WireType.Varint).int32(message.updated_amount_in_cents);
        /* optional string uuid = 31; */
        if (message.uuid !== undefined)
            writer.tag(31, WireType.LengthDelimited).string(message.uuid);
        /* optional string discount = 32; */
        if (message.discount !== undefined)
            writer.tag(32, WireType.LengthDelimited).string(message.discount);
        /* optional fubo.tv.proto.common.v3.generic.PaymentMethod payment_method = 33; */
        if (message.payment_method !== undefined)
            writer.tag(33, WireType.Varint).int32(message.payment_method);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.SubGrowth
 */
export const SubGrowth = new SubGrowth$Type();
